"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _modal = _interopRequireDefault(require("../modal"));

var _loader = _interopRequireDefault(require("../loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var ProjectResetView = /*#__PURE__*/function (_Component) {
  _inherits(ProjectResetView, _Component);

  function ProjectResetView(props) {
    var _this;

    _classCallCheck(this, ProjectResetView);

    _this = _possibleConstructorReturn(this, (ProjectResetView.__proto__ || Object.getPrototypeOf(ProjectResetView)).call(this, props));
    _this.state = {
      loading: false,
      modalOpen: false
    };
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_this));
    _this.openModal = _this.openModal.bind(_assertThisInitialized(_this));
    _this.onRequestToResetProjectRegistration = _this.onRequestToResetProjectRegistration.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ProjectResetView, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: 'comp-project-reset-view'
      }, /*#__PURE__*/_react.default.createElement("h3", null, this.props.title), /*#__PURE__*/_react.default.createElement("p", null, this.props.description), /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "button reset",
        onClick: this.openModal
      }, this.props.resetButtonText), /*#__PURE__*/_react.default.createElement(_modal.default, {
        closeHandler: this.closeModal,
        backgroundClickClose: !this.state.loading,
        escClose: !this.state.loading,
        isOpen: this.state.modalOpen,
        id: 'reset-project-registration-modal'
      }, this.state.loading && /*#__PURE__*/_react.default.createElement(_loader.default, null), !this.state.loading && /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x align-center"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-10 large-12 expanded"
      }, /*#__PURE__*/_react.default.createElement("h2", null, this.props.modalTitle), /*#__PURE__*/_react.default.createElement("div", {
        className: "button-group"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn",
        onClick: this.onRequestToResetProjectRegistration
      }, this.props.confirmText), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn--secondary",
        onClick: this.closeModal
      }, this.props.closeText))))));
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState(function (prev) {
        prev.modalOpen = false;
        return prev;
      });
    }
  }, {
    key: "openModal",
    value: function openModal() {
      this.setState(function (prev) {
        prev.modalOpen = true;
        return prev;
      });
    }
  }, {
    key: "onRequestToResetProjectRegistration",
    value: function onRequestToResetProjectRegistration() {
      var _this2 = this;

      // Loader in ModalBox
      // escClose nad BackgroundClick close are = !loading
      // 1st setState : modal=open
      // 2nd setState : loading=true
      this.setState({
        loading: true
      }, function () {
        // 3rd callbback of setState --> send this.props.request....
        // then --> close modal
        // catch --> close modal (from current impl its not here)
        _this2.props.requestResetProjectRegistration().then(function () {
          _this2.setState({
            modalOpen: false,
            loading: false,
            success: true
          });
        }).catch(function (err) {
          _this2.setState({
            modalOpen: false,
            loading: false,
            success: false,
            error: err.message
          });
        });
      });
    }
  }]);

  return ProjectResetView;
}(_react.Component);

exports.default = ProjectResetView;
ProjectResetView.propTypes = {
  title: _propTypes.default.string.isRequired,
  requestResetProjectRegistration: _propTypes.default.func.isRequired,
  modalTitle: _propTypes.default.string.isRequired,
  confirmText: _propTypes.default.string.isRequired,
  resetButtonText: _propTypes.default.string.isRequired,
  closeText: _propTypes.default.string.isRequired,
  description: _propTypes.default.string
};


//////////////////
// WEBPACK FOOTER
// ./client/components/project-reset-view/index.js
// module id = 763
// module chunks = 0